// formly-table-type.component.ts
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'formly-table-type',
  standalone: true,
  imports: [CommonModule],
  template: `
      <label class="form-label text-muted" style="font-size: 0.875rem; margin-bottom: 0.25rem;">
            <strong>{{ props.label }}</strong>
      </label>   
    <table class="table">
      <thead>
        <tr>
          <th *ngFor="let col of props.columns">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of model">
          <td *ngFor="let col of props.columns">{{ row[col.key] }}</td>
        </tr>
      </tbody>
    </table>
  `,  
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      table, th, td {
        border: 1px solid #bebdba;
        border-collapse: collapse;
      }
    `
  ],
})
export class FormlyTableTypeComponent extends FieldArrayType {}